<template>
  <div
    v-if="activeConditional && currentOrchestrationStep"
    class="flex flex-col"
  >
    <div class="flex items-center space-x-3">
      <icon-base
        v-if="iconForOutcome"
        class="-translate-y-0.5 scale-95 transform"
        :class="{
          'text-warning': activeConditional.outcome === 'manual review',
        }"
        :icon="iconForOutcome"
      />
      <span class="text-base font-medium text-gray-700">
        {{ wordsFirstLetterToUpper(activeConditional.outcome) }}
      </span>
    </div>
    <span class="ml-7">
      {{ currentOrchestrationStepTitle }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import { wordsFirstLetterToUpper } from "@/helpers/formatting";
import { ICON_FOR_CONDITION } from "@/helpers/orchestrationIcons";

import type {
  IActiveConfigPanelConditional,
  IDataService,
  IStep,
} from "@/models/orchestration";

const { getters } = useStore();

const activeConditional = computed<IActiveConfigPanelConditional | null>(() => {
  return getters["orchestration/activeConfigPanelConditional"];
});

const currentOrchestrationStep = computed(() => {
  if (!activeConditional.value?.stepId) {
    return null;
  }
  const steps = getters["orchestration/activeTemplateSteps"] as IStep[];
  return steps.find((s) => s.id === activeConditional.value?.stepId);
});

const currentOrchestrationStepTitle = computed(() => {
  const currentOrchestrationStepServiceInfo: IDataService | undefined = getters[
    "orchestration/serviceInfoByTitle"
  ](currentOrchestrationStep.value?.title);

  const currentOrchestrationStepProvider =
    currentOrchestrationStepServiceInfo?.services?.find(
      ({ id }) => id === currentOrchestrationStep.value?.provider
    );

  return [
    currentOrchestrationStepProvider?.name,
    currentOrchestrationStep.value?.title || currentOrchestrationStep.value?.id,
  ]
    .filter(Boolean)
    .join(" · ");
});

const iconForOutcome = computed(() =>
  activeConditional.value?.outcome
    ? ICON_FOR_CONDITION[activeConditional.value.outcome]
    : null
);
</script>
